module.exports = __webpack_public_path__ + "img/horizontal_2_1_7016.3f6c24d8.png";